<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>Eligible Eyecare Professional Information</legend>
            </div>
            <div class="row">
                <div class="small-6 columns lp">
                    <labeled-input label="First Name" name="First Name" validation='max:20' v-model='sampleobject.firstName'></labeled-input>
                </div>
                <div class="small-6 columns lp">
                    <labeled-input label="Last Name *" validation='required|max:20' name="Last Name" v-model='sampleobject.lastName'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <labeled-input label="Practice Name *" name="Practice Name" v-model='sampleobject.practiceName'></labeled-input>
                </div>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <div class="medium-6 columns lp">
                        <div :class="{'error': errors.has('Role') }">
                            <label for="role">Role at Practice *</label>
                            <select v-validate data-vv-rules="required" v-model="role" name="Role" id="role" class="orderinput-select">
                                <!-- <option selected value> </option> -->
                                <option value="Optician">Optician</option>
                                <option value="Optometrist">Optometrist</option>
                                <option value="Ophthalmologist">Ophthalmologist</option>
                                <option value="Technician">Optical Technician</option>
                                <!-- <option value="Office Manager">Office Manager</option>
                                <option value="Practice Owner">Practice Owner</option> -->
                                <option value="Eyewear Consultant">Eyewear Consultant</option>
                                <!-- <option value="Other">Other</option> -->
                            </select>
                            <p class="error" v-if="errors.has('Role')">{{ errors.first('Role') }}</p>
                        </div>
                    </div>
                    <!--<div class="medium-6 columns lp">
                        <div v-if="showOther" :class="{'error': errors.has('Role (Other)') }">
                            <label for="roleOther">If other, your Role *</label>
                            <input id="roleOther" type="text" v-validate="'required'" name="Role (Other)" class="full-txt" placeholder="" v-model='roleOther'>
                            <p class="error" v-if="errors.has('Role (Other)')">Role is required</p>
                        </div>
                    </div>-->
                </div>

            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <div class="small-12 medium-6 columns lp " v-if="program && program.freeEntry1Label">
                        <!--<div v-if="freeEntry1Choices.length > 0" :class="{'error': errors.has(program.freeEntry1Label) }">-->
                        <div v-if="freeEntry1Choices.length > 0">
                            <label>
                                {{program.freeEntry1Label}}
                                <!--<select class="orderinput-select" :name=" program.freeEntry1Label" v-validate="'required'" v-model="sampleobject.freeEntry1">-->
                                <select class="orderinput-select" :name=" program.freeEntry1Label" v-model="sampleobject.freeEntry1">
                                    <option v-for="c in freeEntry1Choices" :value="c" :key="c">{{c}}</option>
                                </select>
                                <p class="error" v-if="errors.has(program.freeEntry1Label)">{{program.freeEntry1Label}} is required</p>
                            </label>
                        </div>
                        <!--<labeled-input v-else :label="program.freeEntry1Label" :name="program.freeEntry1Label" validation='required' v-model='sampleobject.freeEntry1'></labeled-input>-->
                        <labeled-input v-else="" :label="program.freeEntry1Label" :name="program.freeEntry1Label" v-model='sampleobject.freeEntry1'></labeled-input>
                    </div>

                    <div class="small-12 medium-6 columns lp " v-if="program && program.freeEntry2Label">
                        <div v-if="freeEntry2Choices.length > 0">
                            <label>
                                {{program.freeEntry2Label}}
                                <select class="orderinput-select" :name=" program.freeEntry2Label" v-model="sampleobject.freeEntry2">
                                    <option v-for="c in freeEntry2Choices" :value="c" :key="c">{{c}}</option>
                                </select>
                                <p class="error" v-if="errors.has(program.freeEntry2Label)">{{program.freeEntry2Label}} is required</p>
                            </label>
                        </div>
                        <labeled-input v-else :label="program.freeEntry2Label" :name="program.freeEntry2Label" v-model='sampleobject.freeEntry2'></labeled-input>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="small-12 columns lp">
                    <div class="small-12 medium-6 columns lp " v-if="program && program.freeEntry3Label">
                        <div v-if="freeEntry3Choices.length > 0">
                            <label>
                                {{program.freeEntry3Label}}
                                <select class="orderinput-select" :name=" program.freeEntry3Label" v-model="sampleobject.freeEntry3">
                                    <option v-for="c in freeEntry3Choices" :value="c" :key="c">{{c}}</option>
                                </select>
                                <p class="error" v-if="errors.has(program.freeEntry3Label)">{{program.freeEntry3Label}} is required</p>
                            </label>
                        </div>
                        <labeled-input v-else :label="program.freeEntry3Label" :name="program.freeEntry3Label" v-model='sampleobject.freeEntry3'></labeled-input>
                    </div>

                    <div class="small-12 medium-6 columns lp " v-if="program && program.freeEntry4Label">
                        <div v-if="freeEntry4Choices.length > 0">
                            <label>
                                {{program.freeEntry4Label}}
                                <select class="orderinput-select" :name=" program.freeEntry4Label" v-model="sampleobject.freeEntry4">
                                    <option v-for="c in freeEntry4Choices" :value="c" :key="c">{{c}}</option>
                                </select>
                                <p class="error" v-if="errors.has(program.freeEntry4Label)">{{program.freeEntry4Label}} is required</p>
                            </label>
                        </div>
                        <labeled-input v-else :label="program.freeEntry4Label" :name="program.freeEntry4Label" v-model='sampleobject.freeEntry4'></labeled-input>
                    </div>

                    <div class="small-12 medium-6 columns lp " v-if="program && program.freeEntry5Label">
                        <div v-if="freeEntry5Choices.length > 0">
                            <label>
                                {{program.freeEntry5Label}}
                                <select class="orderinput-select" :name=" program.freeEntry5Label" v-model="sampleobject.freeEntry5">
                                    <option v-for="c in freeEntry5Choices" :value="c" :key="c">{{c}}</option>
                                </select>
                                <p class="error" v-if="errors.has(program.freeEntry5Label)">{{program.freeEntry5Label}} is required</p>
                            </label>
                        </div>
                        <labeled-input v-else :label="program.freeEntry5Label" :name="program.freeEntry5Label" v-model='sampleobject.freeEntry5'></labeled-input>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["selected", "sampleobject", "program"],
  inject: ["$validator"],
  components: { LabeledInput },
  data() {
    return {
      role: "",
      roleOther: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    role() {
      this.sampleobject.role =
        this.role == "Other" ? this.roleOther : this.role;
    },
    roleOther() {
      this.sampleobject.role =
        this.role == "Other" ? this.roleOther : this.role;
    }
  },

  computed: {
    freeEntry1Choices() {
      if (this.program && this.program.freeEntry1Choices) {
        return this.program.freeEntry1Choices.split(",");
      } else {
        return [];
      }
    },
    freeEntry2Choices() {
      if (this.program && this.program.freeEntry2Choices) {
        return this.program.freeEntry2Choices.split(",");
      } else {
        return [];
      }
    },
    freeEntry3Choices() {
      if (this.program && this.program.freeEntry3Choices) {
        return this.program.freeEntry3Choices.split(",");
      } else {
        return [];
      }
    },
    freeEntry4Choices() {
      if (this.program && this.program.freeEntry4Choices) {
        return this.program.freeEntry4Choices.split(",");
      } else {
        return [];
      }
    },
    showOther() {
      return this.role == "Other";
    }
  },
  created() {
    var selectedRole = this.sampleobject.role;
    var roles = [
      "Optician",
      "Optometrist",
      "Ophthalmologist",
      "Technician",
      "Office Manager",
      "Practice Owner",
      "Eyewear Consultant"
    ];
    if (!selectedRole) {
      return; 
    }
    for (let r of roles) {
      if (selectedRole == r) {
        this.role = r;
        this.roleOther = "";
      }
    }
    //this.role = "Other";
    //this.roleOther = selectedRole;
  }
};
</script>
